import React, { useCallback } from 'react';
import { ITicketTemplate } from '../../../services/ticketTemplates/types';

import { ReactComponent as ArrowIcon } from '../../../assets/arrowLeft.icon.svg';

import useStyles from '../styles';
import { useNavigate } from 'react-router-dom';
import { TICKET_TEMPLATE, TICKET_CREATE_FORM } from '../../../router/routes';

interface IProps extends ITicketTemplate {}

const CreateTicketTemplateItem: React.FC<IProps> = ({ id, title }) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const handleRedirect = useCallback(() => {
    if (id !== 0) {
      navigate(TICKET_TEMPLATE.replace(':ticketTemplateId', String(id)));
      return;
    }
    navigate(TICKET_CREATE_FORM);
  }, []);

  return (
    <div className={classes.ticketTemplateItem} onClick={handleRedirect}>
      <div>{title}</div>
      <div className={classes.ticketTemplateItemIcon}>
        <ArrowIcon />
      </div>
    </div>
  );
};

export default CreateTicketTemplateItem;
